import React, { Component } from 'react';
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader'

class POSRefundAmount extends Component {
    constructor(props, context) {
        super(props, context); 
    }

    render()
    {
        const { t } = this.props;
        const p = this.props;

        return (
            <div>
             {/* Confirmation Dialog */}
             <DialogInput
             open={p.show}
             modal={true}
             style={{ zIndex: '950' }}
             title={<DialogHeader text={t('pos.refundAmount.confirmRefund')} classicClass="posDialogClassic" />}
             actions={[
                 <Button
                     key={1}
                     name="buttonRemoveItem"
                     label={t('common.confirm')}
                     className="btnNewBrandPOS"
                     primary={true}
                     onTouchTap={this.props.closeDilog} />]}
                 >
                 <div className="modal-font-family mt-1">
                     <span className='purpleText'>{t('pos.refundAmount.returnAmount', { amount: this.props.refundAmount.toFixed(2) })}</span>
                 </div>
             </DialogInput>
            </div>
        )
    }
}

export default withTranslation()(POSRefundAmount);